export default __webpack_public_path__ + "static/media/13.48e707f7.png";